/*** IMPORTS FROM imports-loader ***/
var define = false;

export default class ChangeImg {

    constructor() {
        this.npoImgSelector = '.great-message__img--npo';
        this.npoImgLgPath = '/dist/img/npo/ui+bird-lg-md@1x.webp';
        this.npoImgSmPath = '/dist/img/npo/ui+bird-sm@1x.webp';
        this.npoImgXsPath = '/dist/img/npo/ui+bird-xs@1x.webp';

        this.decemberSaleImgSelector = '.december-sale-teaser';
        this.decemberSaleImgLgPath = '/dist/img/sales/Sale-Teaser-lg-md@1x.webp';
        this.decemberSaleImgSmPath = '/dist/img/sales/Sale-Teaser-sm@1x.webp';
        this.decemberSaleImgXsPath = '/dist/img/sales/Sale-Teaser-xs@1x.webp';

        this.ebookTimeTrackerImgSelector = '.ebook-time-tracker-img';

        this.ebookFeatureSelectorImgSelector = '.ebook-feature-selector-img';

        this.ebookTTGuideImgSelector = '.ebook-tt-guide-img';

        this.ebookEmployeeReportImgSelector = ".ebook-employee-report-img";

        this.newIndexImgSelector = ".new-index-main-img";
        this.newIndexImgLgPath = '/dist/img/landing/new/enter-tt-main.svg';
        this.newIndexImgMdPath = '/dist/img/landing/new/enter-tt-main-992.svg';
        this.newIndexImgSmPath = '/dist/img/landing/new/enter-tt-main-768.svg';
        this.newIndexImgXsPath = '/dist/img/landing/new/enter-tt-main-phone.svg';

        this.bubbleIndexBackgroundImgSelector = ".new-bubble-img";
        this.bubbleIndexBackgroundImgLgPath = '/dist/img/landing/bubble/enter-tt-main.svg';
        this.bubbleIndexBackgroundImgMdPath = '/dist/img/landing/bubble/enter-tt-main-992.svg';
        this.bubbleIndexBackgroundImgSmPath = '/dist/img/landing/bubble/enter-tt-main-768.svg';
        this.bubbleIndexBackgroundImgXsPath = '/dist/img/landing/bubble/enter-tt-main-phone.svg';

        this.pricingSaleImgSelector = ".pricing-sale-img";
        this.pricingSaleImgLgPath = '/dist/img/pricing/save-18.svg';
        this.pricingSaleImgSmPath = '/dist/img/pricing/save-18-tablet-mobile.svg';

        this.cyberMondayImgSelector = ".cyber-monday-img";
        this.cyberMondayImgLgPath = '/dist/img/cyber-monday/cyber-monday-main.svg';
        this.cyberMondayImgSmPath = '/dist/img/cyber-monday/cyber-monday-main-sm.svg';

        this.cyberMondayPricingImgSelector = ".cyber-monday-pricing-img";
        this.cyberMondayPricingImgLgPath = '/dist/img/pricing/cyber-monday/cyber-monday-sale.svg';
        this.cyberMondayPricingImgSmPath = '/dist/img/pricing/cyber-monday/cyber-monday-sale-sm.svg';

        this.mdWidth = 992;
        this.smWidth = 768;
        this.xsWidth = 480;
    }

    _changeImg(imgClass, imgPath) {
            $(imgClass).attr('src', imgPath);
        }

    _npoChangeImg() {
        if ($(window).width()>this.smWidth) {
            this._changeImg(this.npoImgSelector, this.npoImgLgPath);
        }

        if ($(window).width()<=this.smWidth && $(window).width() > this.xsWidth) {
            this._changeImg(this.npoImgSelector, this.npoImgSmPath);
        }

        if ($(window).width()<=this.xsWidth) {
            this._changeImg(this.npoImgSelector, this.npoImgXsPath);
        }
    }

    _saleChangeImg() {
        if ($(window).width()>this.smWidth) {
            this._changeImg(this.decemberSaleImgSelector, this.decemberSaleImgLgPath);
        }

        if ($(window).width()<=this.smWidth && $(window).width() > this.xsWidth) {
            this._changeImg(this.decemberSaleImgSelector, this.decemberSaleImgSmPath);
        }

        if ($(window).width()<=this.xsWidth) {
            this._changeImg(this.decemberSaleImgSelector, this.decemberSaleImgXsPath);
        }
    }

    _ebookChangeImg() {
        if ($(window).width()>this.mdWidth) {
            this._changeImg(this.ebookFeatureSelectorImgSelector, this.ebookFeatureSelectorImgLgPath);
            this._changeImg(this.ebookTTGuideImgSelector, this.ebookTTGuideImgLgPath);
            this._changeImg(this.ebookEmployeeReportImgSelector, this.ebookEmployeeReportImgLgPath);
        }

        if ($(window).width()>this.smWidth) {
            this._changeImg(this.ebookTimeTrackerImgSelector, this.ebookTimeTrackerImgLgPath);
        }

        if ($(window).width()<=this.mdWidth) {
            this._changeImg(this.ebookFeatureSelectorImgSelector, this.ebookFeatureSelectorImgSmPath);
            this._changeImg(this.ebookTTGuideImgSelector, this.ebookTTGuideImgSmPath);
            this._changeImg(this.ebookEmployeeReportImgSelector, this.ebookEmployeeReportImgSmPath);
        }

        if ($(window).width()<=this.smWidth) {
            this._changeImg(this.ebookTimeTrackerImgSelector, this.ebookTimeTrackerImgSmPath);
        }
    }

    _newIndexImg() {
        if ($(window).width()>this.mdWidth) {
            this._changeImg(this.newIndexImgSelector, this.newIndexImgLgPath);
        }

        if ($(window).width()<=this.mdWidth && $(window).width() > this.smWidth) {
            this._changeImg(this.newIndexImgSelector, this.newIndexImgMdPath);
        }

        if ($(window).width()<=this.smWidth && $(window).width() > this.xsWidth) {
            this._changeImg(this.newIndexImgSelector, this.newIndexImgSmPath);
        }

        if ($(window).width()<=this.xsWidth) {
            this._changeImg(this.newIndexImgSelector, this.newIndexImgXsPath);
        }
    }

    _bubbleIndexBackgroundImg() {
        if ($(window).width()>this.mdWidth) {
            this._changeImg(this.bubbleIndexBackgroundImgSelector, this.bubbleIndexBackgroundImgLgPath);
        }

        if ($(window).width()<=this.mdWidth && $(window).width() > this.smWidth) {
            this._changeImg(this.bubbleIndexBackgroundImgSelector, this.bubbleIndexBackgroundImgMdPath);
        }

        if ($(window).width()<=this.smWidth) {
            this._changeImg(this.bubbleIndexBackgroundImgSelector, this.bubbleIndexBackgroundImgSmPath);
        }

        if ($(window).width()<=this.xsWidth) {
            this._changeImg(this.bubbleIndexBackgroundImgSelector, this.bubbleIndexBackgroundImgXsPath);
        }
    }

    _pricingImg() {
        if ($(window).width()>this.mdWidth) {
            this._changeImg(this.pricingSaleImgSelector, this.pricingSaleImgLgPath);
        }

        if ($(window).width()<=this.mdWidth) {
            this._changeImg(this.pricingSaleImgSelector, this.pricingSaleImgSmPath);
        }
    }

    _cyberMondayImg() {
        if ($(window).width()>this.smWidth) {
            this._changeImg(this.cyberMondayImgSelector, this.cyberMondayImgLgPath);
        }

        if ($(window).width()<=this.smWidth) {
            this._changeImg(this.cyberMondayImgSelector, this.cyberMondayImgSmPath);
        }
    }

    _cyberMondayPricingImg() {
        if ($(window).width()>this.smWidth) {
            this._changeImg(this.cyberMondayPricingImgSelector, this.cyberMondayPricingImgLgPath);
        }

        if ($(window).width()<=this.smWidth) {
            this._changeImg(this.cyberMondayPricingImgSelector, this.cyberMondayPricingImgSmPath);
        }
    }

    _changeImgController() {
        this._npoChangeImg();
        this._saleChangeImg();
        this._ebookChangeImg();
        this._newIndexImg();
        this._bubbleIndexBackgroundImg();
        this._pricingImg();
        this._cyberMondayImg();
        this._cyberMondayPricingImg();

        $(window).resize(() => {
            this._npoChangeImg();
            this._saleChangeImg();
            this._ebookChangeImg();
            this._newIndexImg();
            this._bubbleIndexBackgroundImg();
            this._pricingImg();
            this._cyberMondayImg();
            this._cyberMondayPricingImg();
        })
    }

    init() {
        if ($(".change-img").length === 0) return;
        this._changeImgController();
    }
}



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/modules/ChangeImg.js